import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import LineString from '../geom/LineString';
import BoundaryNodeRule from '../algorithm/BoundaryNodeRule';
import CoordinateArrays from '../geom/CoordinateArrays';
import ArrayList from '../../../../java/util/ArrayList';
import TreeMap from '../../../../java/util/TreeMap';
import MultiLineString from '../geom/MultiLineString';
var BoundaryOp = /*#__PURE__*/function () {
  function BoundaryOp() {
    _classCallCheck(this, BoundaryOp);
    BoundaryOp.constructor_.apply(this, arguments);
  }
  _createClass(BoundaryOp, [{
    key: "boundaryMultiLineString",
    value: function boundaryMultiLineString(mLine) {
      if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
      var bdyPts = this.computeBoundaryCoordinates(mLine);
      if (bdyPts.length === 1) return this._geomFact.createPoint(bdyPts[0]);
      return this._geomFact.createMultiPointFromCoords(bdyPts);
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this._geom instanceof LineString) return this.boundaryLineString(this._geom);
      if (this._geom instanceof MultiLineString) return this.boundaryMultiLineString(this._geom);
      return this._geom.getBoundary();
    }
  }, {
    key: "boundaryLineString",
    value: function boundaryLineString(line) {
      if (this._geom.isEmpty()) return this.getEmptyMultiPoint();
      if (line.isClosed()) {
        var closedEndpointOnBoundary = this._bnRule.isInBoundary(2);
        if (closedEndpointOnBoundary) return line.getStartPoint();else return this._geomFact.createMultiPoint();
      }
      return this._geomFact.createMultiPoint([line.getStartPoint(), line.getEndPoint()]);
    }
  }, {
    key: "getEmptyMultiPoint",
    value: function getEmptyMultiPoint() {
      return this._geomFact.createMultiPoint();
    }
  }, {
    key: "computeBoundaryCoordinates",
    value: function computeBoundaryCoordinates(mLine) {
      var bdyPts = new ArrayList();
      this._endpointMap = new TreeMap();
      for (var i = 0; i < mLine.getNumGeometries(); i++) {
        var line = mLine.getGeometryN(i);
        if (line.getNumPoints() === 0) continue;
        this.addEndpoint(line.getCoordinateN(0));
        this.addEndpoint(line.getCoordinateN(line.getNumPoints() - 1));
      }
      for (var it = this._endpointMap.entrySet().iterator(); it.hasNext();) {
        var entry = it.next();
        var counter = entry.getValue();
        var valence = counter.count;
        if (this._bnRule.isInBoundary(valence)) bdyPts.add(entry.getKey());
      }
      return CoordinateArrays.toCoordinateArray(bdyPts);
    }
  }, {
    key: "addEndpoint",
    value: function addEndpoint(pt) {
      var counter = this._endpointMap.get(pt);
      if (counter === null) {
        counter = new Counter();
        this._endpointMap.put(pt, counter);
      }
      counter.count++;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = null;
      this._geomFact = null;
      this._bnRule = null;
      this._endpointMap = null;
      if (arguments.length === 1) {
        var geom = arguments[0];
        BoundaryOp.constructor_.call(this, geom, BoundaryNodeRule.MOD2_BOUNDARY_RULE);
      } else if (arguments.length === 2) {
        var _geom = arguments[0],
          bnRule = arguments[1];
        this._geom = _geom;
        this._geomFact = _geom.getFactory();
        this._bnRule = bnRule;
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (arguments.length === 1) {
        var g = arguments[0];
        var bop = new BoundaryOp(g);
        return bop.getBoundary();
      } else if (arguments.length === 2) {
        var _g = arguments[0],
          bnRule = arguments[1];
        var _bop = new BoundaryOp(_g, bnRule);
        return _bop.getBoundary();
      }
    }
  }]);
  return BoundaryOp;
}();
export { BoundaryOp as default };
var Counter = /*#__PURE__*/function () {
  function Counter() {
    _classCallCheck(this, Counter);
    Counter.constructor_.apply(this, arguments);
  }
  _createClass(Counter, null, [{
    key: "constructor_",
    value: function constructor_() {
      this.count = null;
    }
  }]);
  return Counter;
}();